import React from "react";
import { container } from "@/utils/mobx";
import { SignUpSectionStore } from "./store";
import { TextInput } from "@/components/toolkit/TextInput";
import { t } from "@/i18n";
import "./s.sign_up_section.css";


export const SignUpSection = container((props: {
    store: SignUpSectionStore
}) => {
    const store = props.store;

    return (
        <div className="sign_up_section">
            <div className="sign_up_section__form">
                <TextInput
                    className="sign_up_section__input"
                    placeholder={t("sign_up_full_name")}
                    value={store.fullName}
                    onChange={(v) => store.setFullName(v)}
                    disabled={store.isLoading}
                />
                <TextInput
                    className="sign_up_section__input"
                    type="email"
                    placeholder={t("sign_up_email")}
                    value={store.email}
                    onChange={(v) => store.setEmail(v)}
                    disabled={store.isLoading}
                />
                <TextInput
                    className="sign_up_section__input"
                    password
                    placeholder={t("sign_up_password")}
                    value={store.password}
                    onChange={(v) => store.setPassword(v)}
                    onEnter={() => store.submit()}
                    disabled={store.isLoading}
                />
                {store.error && (
                    <div className="sign_up_section__error">{store.error}</div>
                )}
                <button
                    className="sign_up_section__button"
                    onClick={() => store.submit()}
                    disabled={store.isLoading}
                >
                    {store.isLoading ? t("sign_up_submitting") : t("sign_up_submit")}
                </button>
            </div>
        </div>
    );
}, SignUpSectionStore);
